/**
 * FREED Page Transition — Black Curtain
 * Enter: curtain reveals upward (0.4s)
 * Exit:  curtain covers downward (0.4s), then navigate
 */
(function () {
  'use strict';

  var DURATION = 400;
  var EASE = 'cubic-bezier(0.76, 0, 0.24, 1)';

  var curtain = document.getElementById('freed-curtain');
  if (!curtain) return;

  // ── Page enter: animate curtain UP to reveal ──────────────────────────────
  if (document.documentElement.classList.contains('freed-entry')) {
    sessionStorage.removeItem('freed-transition');
    document.documentElement.classList.remove('freed-entry');

    // Ensure curtain is covering before we start the reveal animation
    curtain.style.transition = 'none';
    curtain.style.transform = 'translateY(0)';

    // Double rAF ensures browser has painted with curtain covering
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        curtain.style.transition = 'transform ' + DURATION + 'ms ' + EASE;
        curtain.style.transform = 'translateY(-100%)';
      });
    });
  }

  // ── Page exit: slide curtain DOWN then navigate ───────────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;

    // Skip: hash, javascript:, _blank
    if (href === '#' || href.charAt(0) === '#') return;
    if (href.indexOf('javascript:') === 0) return;
    if (link.getAttribute('target') === '_blank') return;

    // Skip external links and cart/checkout
    try {
      var url = new URL(href, window.location.href);
      if (url.hostname !== window.location.hostname) return;
      var p = url.pathname;
      if (p.indexOf('/checkout') === 0 || p.indexOf('/cart') === 0) return;
    } catch (err) {
      return;
    }

    // Skip if modifier keys (open in new tab intent)
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    e.preventDefault();
    sessionStorage.setItem('freed-transition', '1');

    // Cover page
    curtain.style.transition = 'none';
    curtain.style.transform = 'translateY(-100%)';
    curtain.offsetHeight; // force reflow
    curtain.style.transition = 'transform ' + DURATION + 'ms ' + EASE;
    curtain.style.transform = 'translateY(0)';

    setTimeout(function () {
      window.location.href = href;
    }, DURATION);
  }, true); // capture phase so it fires before Shopify's own link handlers

  // ── Back/forward (bfcache): instantly hide curtain ───────────────────────
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      sessionStorage.removeItem('freed-transition');
      curtain.style.transition = 'none';
      curtain.style.transform = 'translateY(-100%)';
      document.documentElement.classList.remove('freed-entry');
    }
  });
})();
